/**
 * Copyright 2022 Design Barn Inc.
 */

import * as React from 'react';

export const UpdateIcon: React.FC = (): JSX.Element => (
  <svg width="310" height="348" viewBox="0 0 310 348" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M59.6374 265.07V193.896L137.538 227.62V263.374L170.628 279.491V316.457L59.6374 265.07Z"
      fill="#1D1D1B"
      stroke="black"
      stroke-width="0.91224"
      stroke-linejoin="bevel"
    />
    <path
      d="M216.929 201.065L137.501 227.933V264.06L216.929 236.15V201.065Z"
      fill="#00DDB3"
      stroke="black"
      stroke-width="0.91224"
      stroke-linejoin="bevel"
    />
    <path
      d="M250.187 252.19L170.628 279.84V316.49L250.187 286.622V252.19Z"
      fill="#00DDB3"
      stroke="black"
      stroke-width="0.91224"
      stroke-linejoin="bevel"
    />
    <path
      d="M217.285 235.338L250.187 252.292L170.333 279.682L137.596 263.77L217.285 235.338Z"
      fill="#D6FEF1"
      stroke="black"
      stroke-width="0.91224"
      stroke-linejoin="bevel"
    />
    <path
      d="M140.138 170.71L59.4926 193.895L138.051 227.836L217.178 201.175L140.138 170.71Z"
      fill="#D6FEF1"
      stroke="black"
      stroke-width="0.91224"
      stroke-linejoin="bevel"
    />
    <ellipse cx="128.893" cy="197.413" rx="41.7357" ry="14.8683" fill="#1D1D1B" />
    <circle cx="136.437" cy="91.0131" r="57.9619" fill="#D6FEF1" />
    <circle cx="136.926" cy="90.9218" r="45.4091" fill="#97FCDB" />
    <path
      d="M94.6665 181.379L94.9411 191.472C95.0164 194.635 96.6598 197.646 99.5428 199.903C105.354 204.425 117.485 210.659 139.603 209.816C139.603 209.816 158.467 209.53 171.77 201.22C174.342 199.605 176.4 197.569 177.789 195.268C179.178 192.966 179.859 190.46 179.782 187.941L179.545 179.251L94.6665 181.379Z"
      fill="#00DDB3"
      stroke="#1D1D1B"
      stroke-width="0.91224"
      stroke-miterlimit="10"
    />
    <mask id="path-10-inside-1_375_56711" fill="white">
      <path d="M167.015 166.666C150.017 159.816 122.788 160.492 106.293 168.174C89.7978 175.856 90.2002 187.673 107.198 194.523C124.197 201.373 151.438 200.687 167.934 193.015C184.429 185.343 184.013 173.526 167.015 166.676" />
    </mask>
    <path
      d="M167.015 166.666C150.017 159.816 122.788 160.492 106.293 168.174C89.7978 175.856 90.2002 187.673 107.198 194.523C124.197 201.373 151.438 200.687 167.934 193.015C184.429 185.343 184.013 173.526 167.015 166.676"
      fill="#D6FEF1"
    />
    <path
      d="M167.354 165.82C158.707 162.335 147.518 160.783 136.44 161.058C125.363 161.333 114.3 163.438 105.906 167.347L106.68 169.001C114.781 165.228 125.58 163.153 136.49 162.882C147.4 162.611 158.324 164.146 166.675 167.512L167.354 165.82ZM105.906 167.347C97.5804 171.224 93.0906 176.338 93.2739 181.689C93.4571 187.035 98.2819 191.913 106.859 195.369L107.538 193.677C99.1168 190.284 95.2413 185.828 95.0974 181.631C94.9538 177.441 98.5103 172.805 106.68 169.001L105.906 167.347ZM106.859 195.369C115.507 198.854 126.699 200.403 137.78 200.127C148.86 199.85 159.927 197.746 168.32 193.842L167.547 192.188C159.445 195.956 148.643 198.031 137.73 198.303C126.817 198.575 115.889 197.043 107.538 193.677L106.859 195.369ZM168.32 193.842C176.646 189.97 181.133 184.858 180.946 179.508C180.759 174.164 175.932 169.287 167.354 165.83L166.676 167.522C175.097 170.916 178.976 175.372 179.123 179.567C179.269 183.756 175.717 188.388 167.547 192.188L168.32 193.842Z"
      fill="black"
      mask="url(#path-10-inside-1_375_56711)"
    />
    <path
      d="M106.312 167.715L106.512 175.074C106.561 177.374 107.755 179.564 109.855 181.202C114.078 184.501 122.906 189.039 139.01 188.417C139.01 188.417 152.733 188.208 162.417 182.17C164.286 180.994 165.782 179.513 166.791 177.839C167.801 176.165 168.297 174.343 168.241 172.51L168.069 166.182L106.312 167.715Z"
      fill="#00DDB3"
      stroke="#1D1D1B"
      stroke-width="0.91224"
      stroke-miterlimit="10"
    />
    <path
      d="M158.015 155.715C146.147 150.738 127.009 151.213 115.466 156.772C103.923 162.331 104.208 170.889 116.116 175.866C128.023 180.842 147.122 180.358 158.665 174.809C170.208 169.26 169.923 160.692 158.015 155.715Z"
      fill="#D6FEF1"
      stroke="black"
      stroke-width="0.91224"
    />
    <path
      d="M158.683 155.388C146.393 150.259 126.694 150.749 114.765 156.479C102.836 162.209 103.142 171.059 115.445 176.188C127.747 181.316 147.446 180.837 159.362 175.097C171.278 169.357 170.986 160.527 158.683 155.388Z"
      fill="#D6FEF1"
      stroke="black"
      stroke-width="0.91224"
    />
    <path
      d="M130.735 95.527L142.479 95.4768C142.934 95.4748 143.371 95.654 143.693 95.9748C144.016 96.2957 144.198 96.7319 144.2 97.1876L144.481 163.277C144.486 164.337 144.07 165.355 143.326 166.107C142.582 166.86 141.57 167.285 140.513 167.29L133.419 167.32C132.362 167.325 131.346 166.908 130.595 166.162C129.845 165.416 129.421 164.401 129.416 163.341L129.135 97.2387C129.133 96.783 129.312 96.3452 129.632 96.0216C129.952 95.698 130.387 95.5151 130.841 95.5132L130.735 95.527Z"
      fill="white"
      stroke="#1D1D1B"
      stroke-width="0.91224"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M144.059 124.482C144.059 124.482 140.815 136.377 129.166 133.789L129.112 121.016L144.059 124.482Z"
      fill="#1D1D1B"
    />
    <path
      d="M136.643 125.262C155.456 125.182 170.641 109.827 170.561 90.9664C170.481 72.1058 155.165 56.8814 136.353 56.9618C117.54 57.0422 102.355 72.397 102.435 91.2576C102.515 110.118 117.831 125.343 136.643 125.262Z"
      fill="#00DDB3"
      stroke="#1D1D1B"
      stroke-width="0.91224"
      stroke-miterlimit="10"
    />
    <path
      d="M149.978 79.0895C141.023 79.1278 137.73 85.5618 135.081 90.7277L133.355 94.025C130.548 99.5112 128.45 102.837 123.003 102.86C122.665 102.86 122.331 102.926 122.019 103.056C121.707 103.186 121.423 103.376 121.185 103.616C120.946 103.856 120.757 104.141 120.629 104.454C120.501 104.767 120.435 105.103 120.437 105.442C120.433 105.781 120.496 106.118 120.622 106.433C120.748 106.748 120.935 107.035 121.171 107.277C121.408 107.52 121.69 107.714 122.001 107.847C122.313 107.98 122.647 108.051 122.985 108.055C131.953 108.016 135.247 101.596 137.882 96.4298L139.622 93.1191C142.428 87.6462 144.526 84.3207 149.96 84.2975C150.644 84.2946 151.298 84.0195 151.779 83.5329C152.26 83.0463 152.529 82.3879 152.526 81.7026C152.523 81.0173 152.249 80.3612 151.764 79.8787C151.278 79.3962 150.622 79.1268 149.938 79.1297L149.978 79.0895Z"
      fill="white"
    />
    <ellipse
      cx="151.344"
      cy="66.9296"
      rx="5.21657"
      ry="2.17357"
      transform="rotate(27.1931 151.344 66.9296)"
      fill="#D6FEF1"
    />
  </svg>
);
